/**
 * Visual-editor schema version — attached to every `visual_editor_*` PostHog
 * event as `editor_version` so usage can be sliced by editor generation over
 * time. Bump this when the editor's capabilities change materially (a new
 * action type, a different save model, a UX rework) so a metric shift can be
 * attributed to the change that caused it rather than read as organic drift.
 *
 * "1.0.0" = the first fully-instrumented version of the deterministic,
 * no-prompt canvas editor (text / style / spacing / link / media / structural
 * edits applied by the element patcher, no AI call).
 *
 * "1.1.0" = colour controls became a first-class surface: a dedicated Colours
 * group with the project's own palette as swatches, validated colour input,
 * one-tap hops to the section (or the element that actually paints the
 * background) behind a selection, and colour patches that hold at every
 * breakpoint and through the gradient-text idiom. Chat now routes whole-site
 * colour requests here instead of attempting them (site_color_routed_to_editor
 * is the entry event), so editor volume in this version is expected to shift
 * upward for reasons other than organic discovery.
 *
 * "1.2.0" = whole-site colour changes became a real capability rather than a
 * promise: the Site colours panel (one row per colour the site paints with,
 * one pick rewriting every use of it across every file, live-previewed and
 * saved through the same no-credit path), a mobile sheet that gives phones
 * their first editor entry of any kind, and a session that survives its own
 * save's reveal-reload. Expect `visual_element_selected` volume per session to
 * FALL for mechanical reasons — the selection no longer has to be re-made
 * after every save — and mobile editor events to appear for the first time.
 */
export const VISUAL_EDITOR_VERSION = "1.2.0";
